import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import {
  Environment,
  ENVIRONMENT_TOKEN,
} from '../../../../apps/values/environment.token';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Auth0Service {
  private _environment: Environment = inject(ENVIRONMENT_TOKEN);
  private _auth = inject(AuthService);
  private _router = inject(Router);

  redirectToAuth0Login(email?: string): void {
    this._auth.loginWithRedirect({
      appState: { target: '/' },
      authorizationParams: {
        ...(email && { login_hint: email }),
      },
    });
  }

  get isAuthenticated$() {
    return this._auth.isAuthenticated$;
  }

  get user$() {
    return this._auth.user$;
  }

  async getAccessToken(): Promise<string | undefined> {
    try {
      const token = await firstValueFrom(
        this._auth.getAccessTokenSilently({
          authorizationParams: {
            audience: this._environment.auth0Audience,
            scope: this._environment.auth0Scope,
          },
        })
      );
      return token;
    } catch (error) {
      console.error('Failed to get access token:', error);
      // Try to re-authenticate if token retrieval fails
      this.redirectToAuth0Login();
      return undefined;
    }
  }

  async getCurrentUser(): Promise<any> {
    try {
      return await firstValueFrom(this._auth.user$);
    } catch (error) {
      return null;
    }
  }
}
